import { useState } from "react";
import { useMutation } from "convex/react";
import { toast } from "sonner";

import { api } from "@constructionautomation/backend";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";

interface CreateProjectInput {
  name: string;
  projectNumber?: string;
  projectAddress?: string;
  projectManagerUserId?: Id<"users">;
  projectAccessUserIds?: Id<"users">[];
}

export function useCreateProject() {
  const createProjectMutation = useMutation(api.projects.create);
  const [isCreating, setIsCreating] = useState(false);

  const createProject = async (input: CreateProjectInput) => {
    setIsCreating(true);
    try {
      const projectId = await createProjectMutation(input);
      toast.success("Project created successfully");
      return projectId;
    } catch (error) {
      toast.error("Failed to create project");
      console.error("Create project error:", error);
      throw error;
    } finally {
      setIsCreating(false);
    }
  };

  return {
    createProject,
    isCreating,
  };
}
